import React from 'react';
import { Link } from 'react-router-dom';

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-200 font-sans">
      <header className="border-b border-slate-800 bg-slate-950/80 backdrop-blur sticky top-0 z-50">
        <div className="container mx-auto px-4 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center gap-3">
            <img src="/official.png" alt="Verisure" className="h-9 w-auto object-contain" />
          </Link>
          <div className="flex items-center gap-4 text-xs font-bold">
            <Link to="/about" className="text-slate-400 hover:text-white transition">About Us</Link>
            <Link to="/terms" className="text-slate-400 hover:text-white transition">Terms</Link>
            <Link to="/login" className="bg-gradient-to-r from-red-600 to-orange-500 text-white px-4 py-2 rounded-xl">
              Sign In
            </Link>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-4xl space-y-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-orange-500/10 border border-orange-500/30 text-orange-400 text-xs font-bold rounded-full mb-3">
            Data Governance & Security
          </div>
          <h1 className="text-3xl md:text-5xl font-black text-white">Privacy & Data Policy</h1>
          <p className="text-slate-400 text-sm mt-2">Compliance with NDPR, GDPR & Enterprise Data Standards</p>
        </div>

        <div className="space-y-8 text-sm leading-relaxed text-slate-300 bg-slate-900/60 border border-slate-800 p-6 md:p-10 rounded-3xl">
          <section>
            <h2 className="text-lg font-bold text-white mb-2 text-orange-400">1. Information We Collect</h2>
            <p>
              To maintain an undisputed equipment audit trail, Verisure collects and cryptographically stores:
            </p>
            <ul className="list-disc list-inside space-y-1.5 mt-2 text-slate-300">
              <li><strong>Asset Telemetry:</strong> Make, model, serial numbers, manufacture year, and condition score metrics.</li>
              <li><strong>Maintenance & Repair Forensics:</strong> High-resolution photographs of faulty and replaced parts, technician reports, and cost breakdowns.</li>
              <li><strong>Verification Metadata:</strong> GPS coordinates and timestamps recorded during on-site field inspections to verify physical asset proximity.</li>
              <li><strong>User & Technician KYC:</strong> Identity document verification, trade certifications, contact information, and business registration.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-2 text-orange-400">2. How Data is Used & Shared</h2>
            <p>
              Verisure utilizes collected maintenance records to:
            </p>
            <ul className="list-disc list-inside space-y-1.5 mt-2 text-slate-300">
              <li>Generate verified maintenance records and QR Identity tags for equipment owners.</li>
              <li>Supply authenticated evidence packages to licensed insurance companies and claims adjusters upon the owner’s request.</li>
              <li>Calculate fair market resale valuations and retention bonuses for equipment secondary markets.</li>
              <li>Prevent equipment theft, fraudulent claims, and unverified part substitutions.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-2 text-orange-400">3. Immutable Ledger & Data Integrity</h2>
            <p>
              Once a maintenance log is committed by a certified technician and verified, its cryptographic hash is sealed. This ensures that historical evidence presented to insurance companies or prospective buyers remains tamper-evident and immune to retroactive manipulation.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-2 text-orange-400">4. Security & Encryption</h2>
            <p>
              All data transmitted to and from the Verisure network is protected using TLS 1.3 encryption in transit and AES-256 encryption at rest. Multi-factor authentication and role-based access control (RBAC) protect sensitive institutional ledgers.
            </p>
          </section>
        </div>
      </main>

      <footer className="py-10 border-t border-slate-800 text-center text-xs text-slate-500">
        <p>&copy; {new Date().getFullYear()} VERISURE • Equipment Maintenance Tracking & Insurance Evidence.</p>
      </footer>
    </div>
  );
};
